import { ListItemIcon, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { StudioIcon } from 'assets/icons';
import { locations } from 'services/routes/locations';
import useAnalytics from 'services/hooks/analytics';
import { events } from 'services/analytics';
import { AnalyticsEventLocation } from 'services/analytics/entities';
import { StyledMenuItem } from './styled';

type PropsType = {
  songId: string;
  isAIGenerated: boolean;
  location: AnalyticsEventLocation;
};
const StudioButton = ({ songId, isAIGenerated, location }: PropsType) => {
  const { t } = useTranslation();
  const { track } = useAnalytics();

  const sendAnalyticsEvent = () => track(events.studioButtonClick(location));

  const title = t('distribution:tooltip:edit');

  return (
    <StyledMenuItem
      // @ts-ignore
      component={Link}
      to={locations.studio.song.pathname(songId, title, isAIGenerated)}
      onClick={sendAnalyticsEvent}
    >
      <ListItemIcon>
        <StudioIcon />
      </ListItemIcon>
      <Typography>{t(title)}</Typography>
    </StyledMenuItem>
  );
};

export default StudioButton;
